<script setup>
import {ref, useSlots, computed} from 'vue'

const slots = useSlots();
const tabProps = ref([]);
const emits = defineEmits(['tabInformation', 'update:selectedTab'])

const props = defineProps({

  selectedTab: {type: String}
})

function setIcon(icon, iconColor) {

  return "<i style=" + "'" + "color:" + iconColor + "'" + " class=" + "'" + icon + "'/i>"
}

function setSelectedTab(tab) {

  emits('update:selectedTab', tab.name)
  emits('tabInformation', tab)
}

// Slots.default creates an array of the dom nodes created from slots
slots.default().forEach(item => {

  if(item.props)
  tabProps.value.push({name: item.props.name, icon: item.props.icon, badgeData: item.props.badgeData,
    iconColor: item.props.iconColor, cssStyle:item.props.style})

})

</script>

<template>
  <div class="cmp-tabs">
    <button
        class="cmp-tabs_tab-button"
        :class="`${props.selectedTab === tab.name && 'cmp-tabs_active-tab'}`"
        :style="tab.cssStyle"
        v-for="(tab, index) in tabProps"
        @click="setSelectedTab(tab)"
        :data-cy="'btnTab' + index"
        :key="tab.name">
      <span><img v-if="tab.icon" :src="tab.icon" class="cmp-tabs_tab-icon"></span><span>{{ tab.name }}</span>
      <div :title="tab.badgeData + ' Records Available'" v-if="tab.badgeData > 0"
           class="cmp-tabs_data-badge" :class="`${props.selectedTab === tab.name && 'cmp-tabs_active-tab-data'}`" >{{tab.badgeData}}</div>
    </button>
    <div class="cmp-tabs_tab-content-area">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">

.cmp-tabs {

  &_tab-button {
     position: relative;
     font-family: inherit;
     height: 30px;
     margin-right: 2px;
     padding-left: 25px;
     padding-right: 25px;
     color: #000000;
     border: 1px solid #cbcbcb;
     border-top-left-radius: 4px;
     border-top-right-radius: 4px;
     //background: #f5f5f5;
      background-image: linear-gradient(0deg, #eaeaea, #ffffff);
   }

  &_active-tab {
    position: relative;
    background: #fff;
    border-bottom: 1px solid #ffffff;
    padding-top: 1px;
  }

  &_active-tab &_tab-icon {
    opacity: 1!important;
  }

  &_active-tab-data {
    background: #168c60 !important;
  }

  &_tab-button:hover {
    background: none;
  }

  &_data-badge {
    position: absolute;
    height: 8px;
    right: 4px;
    top: -7px;
    padding: 0px 4px 3px 4px;
    background: #275087;
    min-width: 5px;
    width: max-content;
    font-size: 9px;
    border-radius: 4px;
    color: white;
  }

  &_tab-content-area {
    border-top: 1px solid #e0e0e0;
    margin-left: -10px;
    margin-top: -1px;
    padding: 20px 0 0 10px;
    user-select: none;
    width: auto;
    overflow-x: auto;
    overflow-y: hidden;
    height: auto;
    //background-color: #fcfcfc;
    background: #ffffff;
  }

  &_tab-icon {
    position: absolute;
    height: 16px;
    width: 16px;
    left: 6px;
    opacity: 0.7;
  }
}
</style>
